import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { SubFormComponent } from '../../sub-form/sub-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-radio-button',
  template: `
<div [formGroup]="group" class="hazard-description  bulk-fields">
  <p class="dyanmic-title dynamic-paragraph" [ngClass]="{'pointer-events' : !field.style.editability}">{{field.name}}<b>*</b> <img (click)="fillForm(undefined)" src="assets/rff-images/bulk.png"></p>
    <ul class="status-bulk-fiels nav" *ngFor="let fields of field.value;let index = index" (click)="fillForm(index)">
      <li>{{getDisplayName(index)}}</li>
    </ul>
</div>
`,
  styles: [`.status-bulk-fiels{background: url(assets/rff-images/formchevronright.svg) no-repeat 97% 54%;background-size : 1.5%}`]
})
export class FormFieldComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  editedIndex: number;
  constructor(
    private modalService: NgbModal
  ) {}
  ngOnInit() {}
  getDisplayName(index) {
    let data = this.field.value[index]['data'];
    let template = this.field.value[index]['template'];
    return data[template.displayFields[0]];
  }
  fillForm(index) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-large',
    };
    const modalRef = this.modalService.open(
      SubFormComponent,
      modalOptions
    );
    const templateId = this.field.data['formTemplateId'];
    modalRef.componentInstance.formId = templateId;
    if (this.field.value && index !== undefined) {
      this.editedIndex = index;
      modalRef.componentInstance.data = this.field.value[index]['data'];
      modalRef.componentInstance.isEditable = true;
    } else {
      this.editedIndex = undefined;
    }
    modalRef.result.then((data) => {      
      if (this.field.value && this.field.value[this.editedIndex]) {
        let finalData = this.field.value[this.editedIndex];
        finalData.data = data.data;
        finalData.template = data.template;
        this.field.value[this.editedIndex] = finalData;
        this.editedIndex = undefined;
      } else {
        const finalData = {
          data: data.data,
          template: data.template
        }
        if (!this.field.value) {
          this.field.value = [];
        }
        this.field.value.push(finalData);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/form-field/form-field.component.ts